import React from "react";

/**
 * HeDesk brand logo — uses /logo.jpeg from public/.
 * Renders as a square rounded image. Use `size` prop in pixels (default 32).
 * Set `glow` to add a soft halo (good for dark backgrounds).
 */
export default function Logo({ size = 32, glow = false, className = "" }) {
  return (
    <span
      className={`relative inline-flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      {glow && (
        <span
          aria-hidden
          className="absolute inset-0 rounded-[22%] bg-cyan-400/30 blur-md"
        />
      )}
      <img
        src="/logo.jpeg"
        alt="HeDesk"
        width={size}
        height={size}
        className="relative w-full h-full rounded-[22%] object-cover"
        loading="eager"
      />
    </span>
  );
}
